export const NewLogoStorageKey = {
  useNewLogoByClubId: 'UseNewLogoByClubId',
} as const;
